import "../Styles/sass/style.scss"
import "../../SharedSiteCode/Scripts/shared";
import '../Components/Widgets/VerticalForm/vertical-form';
import "../Components/FormSections/form-fields";
import '../Components/Widgets/UgRibbon/ug-hero';
import deBounce from 'lodash.debounce';

jQuery(document).ready(function ($) {
    $(document).on('click', '#lead-cash-offer-btn', function (e) {
        e.preventDefault();
        const $form = $(this).closest('form');
        const $redirectInput = $form.find('#form-redirect-url');

        if ($redirectInput.length > 0) {
            const redirectUrl = $redirectInput.val();
            window.location.href = redirectUrl;
        } else {
            window.location.href = "/contact-us/";
        }
    });

    // Market subnav
    $("#menu-inner-location-nav label").on("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        var checkBox = $(this).prev('input');
        var isChecked = checkBox.prop("checked");

        if (Foundation.mediaQuery.MediaQuery.atLeast('larger')) {
            // desktop radios - only one checked/submenu open at once
            checkBox.prop("checked", !isChecked);
        } else {
            // mobile checkboxes - manually close others
            if (!isChecked) {
                $('#menu-inner-location-nav input[type="checkbox"]').not(checkBox).prop('checked', false);
            }
            checkBox.prop("checked", !isChecked);

            if (checkBox.prop("checked")) {
                if ($('.market-hamburger').is(':visible')) {
                    // scroll to top on submenu open
                    $('html, body').scrollTop(0);
                }
            }
        }
    });

    $(document).click(function (event) {
        var $target = $(event.target);
        if (!$target.closest('#menu-inner-location-nav').length && !$target.closest('.market-hamburger').length) {
            $('#menu-inner-location-nav input').prop('checked', false);
            $('.market-hamburger').removeClass('is-active');
        }
    });

    // make sub nav check box to radio based on the device
    $(window).on('load resize', deBounce(() => {
        if (Foundation.mediaQuery.MediaQuery.atLeast('larger')) { //breakpoint should match when the menu expands from mobile to desktop
            checkboxToRadio();
        } else {
            radioToCheckbox();
        }
    }, 50));

    function checkboxToRadio() {
        $("#menu-inner-location-nav > li.menu-item").each(function () {
            if ($(this).find("input[type='checkbox']").length) {
                $(this).find("input[type='checkbox']").attr('name', 'subnav-dropdown')
                $(this).find("input[type='checkbox']").attr('type', 'radio')
            }
        });
    }

    function radioToCheckbox() {
        $("#menu-inner-location-nav > li.menu-item").each(function () {
            if ($(this).find("input[type='radio']").length) {
                $(this).find("input[type='radio']").attr('name', $(this).find("input[type='radio']").attr("id"))
                $(this).find("input[type='radio']").attr('type', 'checkbox')
            }
        });
    }
});

jQuery(window).on('load', function () {
    $('iframe[src*="youtube"]').each(function () {
        $(this).wrap('<div class="video-responsive"></div>');
    });
});
